import React from 'react';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../../store/hooks';
import {
  TicketFilterOptionsSelector,
  TicketsCountSelector,
  TicketsLoadingStateSelector,
  TicketsSelector,
} from '../../../../store/tickets/selectors';
import { PortalConfigSelector } from '../../../../store/config/selectors';
import { sortById } from '../../../../store/tickets';

import TicketListItem from './components/TicketListItem';
import { ReactComponent as UpDownArrow } from '../../../../assets/upDown.icon.svg';

import useStyles from '../../styles';
import { tt } from '@i18n/tt';
import { TableTypes } from '../../../../components/Table/constants';
import { UserRoleSelector } from '../../../../store/user/selector';
import TicketsTable from './components/TicketsTable';
import { Roles } from '../../../../constants/roles';

const TicketsList: React.FC = () => {
  const config = useAppSelector(PortalConfigSelector);
  const tickets = useAppSelector(TicketsSelector);
  const ticketsCount = useAppSelector(TicketsCountSelector);
  const isTicketsLoading = useAppSelector(TicketsLoadingStateSelector);
  const { closeStatusId } = useAppSelector(TicketFilterOptionsSelector);
  const role = useAppSelector(UserRoleSelector);
  const isAdminManagerRole = role === Roles.Admin || role === Roles.Manager;
  const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <div className={classes.ticketsList}>
      <div className={classes.ticketListHeader}>
        <div className={classes.ticketsStats}>
          <div>
            <UpDownArrow
              onClick={() => {
                dispatch(sortById());
              }}
            />
          </div>

          <div>
            {tt('table.total')}: {ticketsCount}
          </div>
        </div>

        <div className={classes.ticketsListLoading}>
          {isTicketsLoading && !isAdminManagerRole && <CircularProgress style={{ width: '24px', height: '24px' }} />}
        </div>
      </div>
      {isAdminManagerRole ? <TicketsTable /> : tickets.map(ticket => (
        <TicketListItem
          ticket={ticket}
          disableChats={config.disableChats}
          key={ticket.id}
          closeStatusId={closeStatusId}
        />
      ))}
    </div>
  );
};

export default TicketsList;
